export default {
  data() {
    return {
      // Drag functionality
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      currentModal: null,
    };
  },
  methods: {
    // Drag methods
    startDrag(event, modalElement) {
      this.isDragging = true;
      this.currentModal = modalElement;
      const rect = modalElement.getBoundingClientRect();
      
      // Calculate offset from click position within the modal
      this.dragOffset.x = event.clientX - rect.left;
      this.dragOffset.y = event.clientY - rect.top;
      
      // Store original dimensions before changing position
      const originalWidth = rect.width;
      const originalHeight = rect.height;
      
      // Set initial position and dimensions based on current position
      modalElement.style.position = 'fixed';
      modalElement.style.left = rect.left + 'px';
      modalElement.style.top = rect.top + 'px';
      modalElement.style.width = originalWidth + 'px';
      modalElement.style.height = originalHeight + 'px';
      modalElement.style.transform = 'none';
      modalElement.style.margin = '0';
      modalElement.style.maxWidth = 'none';
      modalElement.style.maxHeight = 'none';
      
      // Remove centering classes from parent
      const modalContainer = modalElement.parentElement;
      modalContainer.classList.remove('flex', 'items-center', 'justify-center');
      modalContainer.classList.add('flex');
      
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
      event.preventDefault();
    },
    onDrag(event) {
      if (!this.isDragging || !this.currentModal) return;
      
      const x = event.clientX - this.dragOffset.x;
      const y = event.clientY - this.dragOffset.y;
      
      // More flexible viewport constraints
      const modalRect = this.currentModal.getBoundingClientRect();
      const headerHeight = 60; // Approximate header height to keep visible
      const siteHeaderHeight = 80; // Height of the site's fixed header
      
      // Allow dragging outside viewport but keep header accessible
      const minX = -modalRect.width + 100; // Keep at least 100px visible on the right
      const maxX = window.innerWidth - 100; // Keep at least 100px visible on the left
      const minY = siteHeaderHeight; // Don't allow dragging behind the site header
      const maxY = window.innerHeight - headerHeight; // Allow dragging below viewport but keep header visible
      
      const boundedX = Math.max(minX, Math.min(x, maxX));
      const boundedY = Math.max(minY, Math.min(y, maxY));
      
      this.currentModal.style.left = boundedX + 'px';
      this.currentModal.style.top = boundedY + 'px';
      this.currentModal.style.transform = 'none';
    },
    stopDrag() {
      this.isDragging = false;
      this.currentModal = null;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    resetModalPosition() {
      // Reset any dragged modal positions when closing
      setTimeout(() => {
        const modals = document.querySelectorAll('[ref*="Modal"]');
        modals.forEach(modal => {
          if (modal && modal.parentElement) {
            const container = modal.parentElement;
            container.classList.add('flex', 'items-center', 'justify-center');
            modal.style.position = '';
            modal.style.left = '';
            modal.style.top = '';
            modal.style.width = '';
            modal.style.height = '';
            modal.style.transform = '';
            modal.style.margin = '';
            modal.style.maxWidth = '';
            modal.style.maxHeight = '';
          }
        });
      }, 50);
    }
  },
  beforeUnmount() {
    // Cleanup event listeners
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
  }
};
